export default class News {
    constructor(titles, tagLines, contents, categories, featuredImage, files, images, publishDate) {
        // {} instead of array to support stringify        
        this.titles = titles;
        this.tagLines = tagLines;
        this.contents = contents;

        this.categories = categories;
        this.featuredImage = featuredImage;
        this.files = files;
        this.images = images;
        this.publishDate = publishDate;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tagLines)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }

        if(result) result = this.categories && this.categories.length && this.featuredImage;

        return result;
    }
}